var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" Distributior setting "),
      ]),
      _c("button", {
        staticClass: "delete",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("on-close")
          },
        },
      }),
    ]),
    _c(
      "section",
      { staticClass: "modal-card-body" },
      [
        _c(
          "div",
          { staticClass: "mb-5" },
          [
            _c(
              "b-tag",
              {
                staticClass: "mb-2",
                attrs: { type: "is-info", size: "is-medium", rounded: "" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.distributor.id) +
                    " - " +
                    _vm._s(_vm.distributor.name) +
                    " "
                ),
              ]
            ),
            _c(
              "b-tag",
              { attrs: { type: "is-info", size: "is-medium", rounded: "" } },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.distributor.address || "") +
                    " " +
                    _vm._s(_vm.distributor.city) +
                    ", " +
                    _vm._s(_vm.distributor.country) +
                    " "
                ),
              ]
            ),
          ],
          1
        ),
        _c("b-loading", {
          attrs: { "is-full-page": false },
          model: {
            value: _vm.isLoading,
            callback: function ($$v) {
              _vm.isLoading = $$v
            },
            expression: "isLoading",
          },
        }),
        _c(
          "b-field",
          { attrs: { label: "Group" } },
          [
            _c(
              "b-select",
              {
                attrs: { placeholder: "Select a group..." },
                model: {
                  value: _vm.selectedGroup,
                  callback: function ($$v) {
                    _vm.selectedGroup = $$v
                  },
                  expression: "selectedGroup",
                },
              },
              _vm._l(_vm.groups, function (group) {
                return _c(
                  "option",
                  { key: group.collectGroup, domProps: { value: group } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(group.collectGroup) +
                        " - " +
                        _vm._s(group.description) +
                        " "
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
        _c(
          "b-field",
          { attrs: { label: "Comment" } },
          [
            _c("b-input", {
              attrs: { type: "text", placeholde: "Write a comment..." },
              model: {
                value: _vm.comment,
                callback: function ($$v) {
                  _vm.comment = $$v
                },
                expression: "comment",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mt level-right" },
          [
            _c(
              "b-button",
              {
                attrs: { type: "is-primary", loading: _vm.isLoading },
                on: { click: _vm.save },
              },
              [_vm._v(" Save ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }